// height of row should vary based on density
export const RowHeight = 60;
export const ActionIconSize = 36;
export const ActionCellPaddingSize = 32;
export const CheckboxCellSize = 52;
